import styled from 'styled-components';

import { palette, pxToRem } from '../../styles';


type SegmentProps = {
	isActive: boolean;
	disabled: boolean;
};

const Root = styled.div`
	position: relative;
	top: 1px;
	display: inline-flex;
	flex-flow: row wrap;

	& .segment-button-layout:first-child button {
		border-radius: 2px 0 0 2px;
	}

	& .segment-button-layout:last-child button {
		border-radius: 0 2px 2px 0;
	}
`;

const Segment = styled.button`
	z-index: 1;
	width: auto;
	background-color: ${palette.whitePrimary};
	color: ${palette.blackPrimary};
	outline: none;
	cursor: pointer;
	font-family: Roboto, 'Arial';
	font-weight: 500;
	font-size: ${pxToRem(13)};
	border: 1px solid #BFBFBF;
	padding: 6px 16px;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	text-align: center;

	${(p: SegmentProps) => p.isActive && `
		background-color: #8C8C8C;
		color: ${palette.whitePrimary};
	`}

	${(p: SegmentProps) => p.disabled && `
		background-color: ${palette.blackDisabled};
		color: ${palette.whitePrimary};
		border-color: ${palette.whitePrimary};
	`}
`;

const SegmentLayout = styled.div.attrs({
	className: 'segment-button-layout'
})`
	margin-left: -1px;
	margin-top: -1px;
`;

export {
	Root,
	Segment,
	SegmentLayout,
};
